import type { AdminAppointmentsQuery } from "@takt/api-client"
import type { CalendarView } from "../companies/company-local-time"

export type AppointmentStatus = NonNullable<AdminAppointmentsQuery["status"]>
export type AppointmentSource = NonNullable<AdminAppointmentsQuery["bookedFrom"]>
export type AppointmentScope = "all" | "today" | "next24" | "next7" | "past" | "7d"
export type AppointmentView = "list" | CalendarView

export type AppointmentsSearch = {
    q?: string
    companyId?: number
    status?: AppointmentStatus
    source?: AppointmentSource
    scope?: AppointmentScope
    view?: AppointmentView
    date?: string
}

const statuses = new Set<AppointmentStatus>(["pending", "confirmed", "rejected", "completed", "cancelled", "noShow"])
const sources = new Set<AppointmentSource>(["admin", "public", "phone", "walkIn"])
const scopes = new Set<AppointmentScope>(["all", "today", "next24", "next7", "past", "7d"])
const views = new Set<AppointmentView>(["list", "day", "week"])
const asString = (value: unknown) => (typeof value === "string" && value.trim() ? value.trim() : undefined)

export function validateAppointmentsSearch(search: Record<string, unknown>): AppointmentsSearch {
    const q = asString(search.q)
    const companyIdValue = Number(search.companyId)
    const companyId = Number.isSafeInteger(companyIdValue) && companyIdValue > 0 ? companyIdValue : undefined
    const statusValue = asString(search.status) as AppointmentStatus | undefined
    const sourceValue = asString(search.source) as AppointmentSource | undefined
    const scopeValue = asString(search.scope) as AppointmentScope | undefined
    const viewValue = asString(search.view) as AppointmentView | undefined
    const dateValue = asString(search.date)
    return {
        ...(q ? { q } : {}),
        ...(companyId ? { companyId } : {}),
        ...(statusValue && statuses.has(statusValue) ? { status: statusValue } : {}),
        ...(sourceValue && sources.has(sourceValue) ? { source: sourceValue } : {}),
        ...(scopeValue && scopes.has(scopeValue) && scopeValue !== "all" ? { scope: scopeValue } : {}),
        ...(viewValue && views.has(viewValue) && viewValue !== "list" ? { view: viewValue } : {}),
        ...(dateValue && /^\d{4}-\d{2}-\d{2}$/.test(dateValue) ? { date: dateValue } : {}),
    }
}
